<template>
  <!-- <div> -->
  <!-- <HeroSection /> -->
  <div class="calculators">
    <div class="container">
      <Calculators />
      <Articles />
      <FAQ v-if="$store.state.calculators.calculator !== 'variance'" />
    </div>
    <div class="up-arrow-wrapper">
      <a
        class="up-arrow-btn"
        :class="{ 'visible': scrolled }"
        @click="scrollToTop"
      >
        <UpArrow />Top
      </a>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import Calculators from '../../components/Calculators/Content/Calculators';
// import HeroSection from '../../components/Calculators/HeroSection.vue';
import Articles from '../../components/Calculators/Content/Articles';
import FAQ from '../../components/Calculators/Content/FAQ';
import UpArrow from '../../assets/svg/icon-arrow-blog-up.svg?vue-component';

export default {
  components: {
    Calculators,
    Articles,
    UpArrow,
    FAQ,
    // HeroSection,
  },
  mixins: [global],
  middleware({ $config, error }) {
    if ($config.platform === 'fa') {
      return error({ statusCode: 404, message: 'Page not found' });
    }
    return true;
  },
  data() {
    return {
      scrolled: false,
      metaTitles: {
        'confidence-interval-calculator': 'Confidence Interval Calculator',
        'mean-median-mode-calculator': 'Mean, Median, Mode Calculator',
        'skewness-calculator': 'Skewness Calculator',
        'kurtosis-calculator': 'Kurtosis Calculator',
        'variance-calculator': 'Variance Calculator',
        'standard-deviation-calculator': 'Standard Deviation Calculator',
        'coefficient-of-variation-calculator': 'Coefficient of Variation Calculator',
      },
    };
  },
  head() {
    const metaDescription = `Do you need to find a ${this.metaTitles[this.$route.path.split('/')[2]]} quickly? Input your data to obtain the metric, step-by-step calculation, Python and R codes, ${this.$route.path.split('/')[2] === 'mean-median-mode-calculator' ? 'etc' : 'and more'}. Calculate now.`;

    return {
      titleTemplate: `${this.metaTitles[this.$route.path.split('/')[2]]} | 365 Data Science`,
      meta: this.metaProps({ metaDescription }),
      script: [
        { src: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/MathJax.js?config=TeX-MML-AM_SVG', async: true },
      ],
    };
  },
  created() {
    this.handleScroll();
  },
  methods: {
    scrollToTop() {
      if (process.client) {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      }
    },
    handleScroll() {
      if (process.client) {
        window.onscroll = () => {
          this.scrolled = window.scrollY > 0 && this.$store.state.layout === 'desktop';
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.calculators {
  padding-top: var(--spacing-160);
  background: var(--main-light-shade-1);

  .up-arrow-wrapper {
    width: 56px;
    margin: 0 125px 0 auto;
    padding-bottom: var(--spacing-60);
    position: sticky;
    bottom: -6px;
    transition: all var(--duration) ease-in;

    .up-arrow-btn {
      width: 56px;
      height: 56px;
      background: var(--main-dark-shade-1);
      border-radius: 3px;
      color: var(--main-light);
      padding: var(--spacing-12);
      text-align: center;
      opacity: 0;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;

      &.visible {
        opacity: 1;
      }

      svg {
        margin-bottom: 5px;

        path[stroke] {
          stroke: var(--main-light);
        }
      }

      &:hover {
        color: var(--main-light);
      }
    }
  }
}

@include bp($bp-mobile) {
  .calculators {
    overflow: hidden;
    padding-top: 136px;

    .container {
      padding: 0;
    }

    .up-arrow-wrapper {
      display: none;
    }
  }
}
</style>
